import type { IndicatorPeriodPayload } from '@Application/Indicators/Actions/indicatorPeriodPayload';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class IndicatorPeriodView {
	readonly days: number;
	readonly from: Date;
	readonly to: Date;
	readonly previousFrom: Date;

	constructor(payload: IndicatorPeriodPayload) {
		this.days = payload.days;
		this.from = new Date(payload.from);
		this.to = new Date(payload.to);
		this.previousFrom = new Date(payload.previousFrom);

		Object.freeze(this);
	}
}

export default IndicatorPeriodView;
